import { render, staticRenderFns } from "./AssignmentDashboard.vue?vue&type=template&id=0882b229&scoped=true&"
import script from "./AssignmentDashboard.vue?vue&type=script&lang=js&"
export * from "./AssignmentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentDashboard.vue?vue&type=style&index=0&id=0882b229&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882b229",
  null
  
)

export default component.exports